/**
 * @function removeEmptyProp
 * This function allows you remove all empty props from an object.
 * @param data
 * @returns Object without empty props
 */
export const removeEmptyProp = <T>(data: T) => {
  const formatData = { ...data }
  Object.keys(formatData).forEach((key) => {
    const value: any = formatData[key]
    return (
      (value === null ||
        value === '' ||
        (value && value.length === 0) ||
        value === undefined) &&
      delete formatData[key]
    )
  })
  return formatData as T
}
